import React from 'react';
import './StatusIcon.css';
import classNames from 'classnames';

interface Props {
  text?: string;
  color: string;
  reversed?: boolean;
}

export function StatusIcon({ text, color, reversed }: Props): JSX.Element {
  return (
    <div className={classNames('status_icon', reversed && `status_icon--direction-reversed`)}>
      {text}
      <svg height="20" width="20">
        <circle cx="10" cy="10" r="5" fill={color} strokeWidth="7" />
      </svg>
    </div>
  );
}
